/**
 * Class composition and the one icon weight, kept out of the component files so
 * those export components alone (Fast Refresh).
 */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}

/**
 * §12: icons are monoline at 1.5. Windows specifies a single 1 epx stroke;
 * Tabler draws at 2, which beside Fluent reads as a heavier family rather than a
 * different one. 1.5 is as thin as Tabler's geometry stays legible at 16px.
 */
export const ICON_STROKE = 1.5;
